module.exports = __webpack_public_path__ + "img/telegram-fill.8f03ef85.svg";